import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withSetPropAction } from '../extensions/withSetPropAction';
import { OperatorInfo } from '../operator-info/OperatorInfo';

/**
 * # Role
 *
 * Role 설명하세요.
 */
export const Role = types
  .model('Role')
  .props({
    roleId: types.optional(types.string, ''),
    dscrpt: types.optional(types.string, ''),
    regDt: types.optional(types.string, ''),
    updDt: types.optional(types.string, ''),
    // 구버전
    regId: types.optional(types.number, 0),
    updId: types.optional(types.number, 0),
    // 신버전
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
  })
  .actions(withSetPropAction);

type TRole = Instance<typeof Role>;
type TRoleSnapshot = SnapshotOut<typeof Role>;

export interface IRole extends TRole {}
export type TRoleKeys = keyof TRoleSnapshot & string;
export interface IRoleSnapshot extends TRoleSnapshot {}
export const createRole = () => types.optional(Role, {} as TRole);
